





































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { directPayloadQuery } from '@/utils/api'
import apiCodic from '@/api/codic'
import { AloCodicInfosSection } from '@/models/alo/AloCodicInfosSection'
import { AloCodicSection } from '@/models/alo/AloCodicSection'
import { AloCodicInfoTree, getDefaultAloCodicInfoTree } from '@/models/alo/AloCodicInfoTree'

@Component({
  name: 'GestionCodic',  
})
export default class GestionCodic extends Vue {
  private codic = ''
  private loading = false
  private codicInfos:AloCodicInfoTree = getDefaultAloCodicInfoTree()

   private headers(section:AloCodicSection) { 
     const nbOffre = section.infoHeaders.length
     const header = [{ text: 'Champs', value: 'infoName', width:150 }]
     section.infoHeaders.forEach((title,idx) => {
        //@ts-ignore
        header.push({text:title,value:`data_${idx}`,sortable:false})
     })     
     header.push({ text: 'Commentaire', value: 'infoLibelle', width:350 })
     return header
   }

  get sections() {
    return [...this.codicInfos.productSections,...this.codicInfos.offersSections]
  }

  searchCodic() {
    if(this.codic == null || this.codic.length == 0){
      this.codicInfos  = getDefaultAloCodicInfoTree()
      this.codicInfos.offersSections
    }
    else {
      this.loading = true    
      directPayloadQuery(apiCodic.getInfosCodic,this.codic,this.$store).then((codicInfos)=>{
        this.codicInfos = {...getDefaultAloCodicInfoTree(),...codicInfos}
      })
      .catch(()=>{
        this.codicInfos  = getDefaultAloCodicInfoTree()
      })
      .finally(()=>{
        this.loading = false
      })
    }
  }
}
